import type { ReactNode } from 'react';

import { AlertModalBox, AlertModalIconBox, AlertModalContent } from './AlertModal.styled';
import { ModalBackground } from './Modals.styled';

import type { BoxProps } from '@m/components/uikit';

interface AlertModalProps extends BoxProps {
  children?: ReactNode;
  icon?: ReactNode;
  onCancel?: () => void;
  show?: boolean;
}

export function AlertModal({
  icon,
  show = false,
  onCancel = () => {},
  children,
  ...modalContentProps
}: AlertModalProps) {
  return (
    <AlertModalBox show={show}>
      <ModalBackground onClick={onCancel} />
      <AlertModalContent show={show} {...modalContentProps}>
        {icon && <AlertModalIconBox>{icon}</AlertModalIconBox>}
        {children}
      </AlertModalContent>
    </AlertModalBox>
  );
}
